import React from "react";
import { FootballState } from "@prestosports/prestostats-core/Football";
import classNames from "classnames";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PlayInitialStep from "./PlayInitialStep";
import PlayStateTransitions from "./PlayStateTransitions";
import FragmentFieldView from "./FragmentFieldView";
import StepHeader from "./field-selectors/StepHeader";
import PlaySummary from "./PlaySummary";
import playStepContentStyles from "../styles/PlayStepContent.styles";
import commonStyles from "../../common/styles/Common.styles";

const PlayStepContent = ({
	play,
	steps,
	stepIndex,
	onSelectTransition,
	lastStep
}) => {
	const commonClasses = commonStyles();
	const classes = playStepContentStyles();
	const xsScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

	const step = steps.find((s) => s.index === stepIndex);
	const {
		fragment,
		requiredData,
		state,
		title,
		subtitle,
		positionPref,
		team,
		canBeFinalized,
		nextTransition,
		validationMessages,
		defaultValue,
		restrictedPositions
	} = step || {};

	const {
		isResult: isLastStepResult,
		canBeFinalized: canLastStepBeFinalized,
		index: lastStepIndex
	} = lastStep || {};

	const hideControls =
		!(isLastStepResult && canLastStepBeFinalized) || lastStepIndex !== stepIndex;

	const onSelect = (transition) => {
		onSelectTransition(transition, fragment && fragment.associatedHistoryIndex);
	};

	// The fit layout divides the panel height across however many action rows
	// there are, so it holds for any sport's action set. On phones the actions
	// stack and scrolling is expected, so only fit them on larger screens.
	const fitActionsToPanel = !xsScreen;

	const showInitialStep = () => {
		return (
			<>
				<PlayInitialStep
					fitHeight={fitActionsToPanel}
					additionalActions={
						<PlayStateTransitions
							buttonSize={xsScreen ? "small" : "medium"}
							onSelectTransition={onSelect}
							columns={3}
							fitHeight={fitActionsToPanel}
							currentTransition={nextTransition}
						/>
					}
				/>
				{/* <GameStats /> */}
			</>
		);
	};

	const showPlayStep = () => {
		let playStep = null;
		if (!requiredData) {
			playStep = (
				<PlayStateTransitions
					onSelectTransition={onSelect}
					buttonSize="small"
					textAlign="center"
					currentTransition={nextTransition}
					hideIcons
				/>
			);
		} else if (fragment) {
			playStep = (
				<FragmentFieldView
					play={play}
					fragment={fragment}
					fragmentField={requiredData}
					team={team}
					stepIndex={stepIndex}
					positionPref={positionPref}
					defaultValue={defaultValue}
					restrictedPositions={restrictedPositions}
				/>
			);
		}

		return playStep;
	};

	function isDriveStart() {
		return state === FootballState.StartDrive;
	}

	return (
		<>
			<StepHeader
				title={title}
				subtitle={subtitle}
				showRestart={!!step && state !== FootballState.AddPlay && !isDriveStart()}
				showHeader={state !== FootballState.AddPlay}
			/>
			<div
				className={classNames(classes.mainContent, commonClasses.scrollableContent)}
			>
				{!requiredData && canBeFinalized && (
					<PlaySummary
						hideControls={hideControls}
						play={play}
						validationMessages={validationMessages}
					/>
				)}
				{state === FootballState.AddPlay ? showInitialStep() : showPlayStep()}
			</div>
		</>
	);
};

export default PlayStepContent;
